import { BookingObjectType } from 'src/components/BookingObjectTypeSelect/types';
import { PlaceType, RoomType } from 'src/types';

export const bookingObjectTypeByRoomType: Record<RoomType, BookingObjectType> =
  {
    [RoomType.Focus]: BookingObjectType.FocusRoom,
    [RoomType.Meeting]: BookingObjectType.MeetingRoom,
    [RoomType.Phone]: BookingObjectType.PhoneRoom,
  };

export const roomTypeByBookingObjectType: Record<
  | BookingObjectType.FocusRoom
  | BookingObjectType.MeetingRoom
  | BookingObjectType.PhoneRoom,
  RoomType
> = {
  [BookingObjectType.FocusRoom]: RoomType.Focus,
  [BookingObjectType.MeetingRoom]: RoomType.Meeting,
  [BookingObjectType.PhoneRoom]: RoomType.Phone,
};

export const toBookingObjectType = (
  placeType: PlaceType,
  roomType?: RoomType | null,
): BookingObjectType => {
  switch (placeType) {
    case PlaceType.Desk:
      return BookingObjectType.Desk;
    case PlaceType.Parking:
      return BookingObjectType.Parking;
  }

  return bookingObjectTypeByRoomType[roomType ?? RoomType.Meeting];
};
